import {Component, HostListener, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {User} from '../../../models/user.model';
import {AuthService} from '../../../account/shared/auth.service';
import {Router} from '@angular/router';
import {OffcanvasService} from '../../shared/offcanvas.service';

@Component({
  selector: 'app-tool-bar',
  templateUrl: './tool-bar.component.html',
  styleUrls: ['./tool-bar.component.scss']
})
export class ToolBarComponent implements OnInit {

  private authSubscription: Subscription;
  public user: User;
  isAccountDropdownOpen = false;


  showSearch: boolean = false;
  accountDropdownVisible: boolean = false;
  mobileMenuVisible: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private offcanvasService: OffcanvasService
  ) {}

  ngOnInit() {
    this.authSubscription = this.authService.user.subscribe((user) => {
      this.user = user;
    });
  }

  public onLogOut(e: Event) {
    this.authService.signOut();
    this.router.navigate(['/register-login']);
    e.preventDefault();
  }

  public onMenuToggle(e: Event) {
    this.offcanvasService.openOffcanvasNavigation();
    e.preventDefault();
  }

  ngOnDestroy() {
    this.authSubscription.unsubscribe();
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const header = document.querySelector('.navbar-sticky');
    if (window.scrollY > 50) {
      header?.classList.add('scrolled');
    } else {
      header?.classList.remove('scrolled');
    }
  }
  toggleSearch() {
    this.showSearch = !this.showSearch;
  }

  toggleOffCanvas() {
    this.offcanvasService.openOffcanvasNavigation();
  }

  toggleMobileMenu() {
    this.mobileMenuVisible = !this.mobileMenuVisible;
  }



  hideSearch(): void {
    this.showSearch = false;
  }

  toggleAccountDropdown(): void {
    this.isAccountDropdownOpen = !this.isAccountDropdownOpen;
  }

  closeAccountDropdown(): void {
    this.isAccountDropdownOpen = false;
  }



}
